module.exports = __webpack_public_path__ + "static/media/NISM_Online_examination-Instructions_to_Candidates.c0188a56.pdf";